/** TubeTrailMesh resource slice: claims the type name. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('tubetrailmesh', ['TubeTrailMesh']);
//# sourceMappingURL=index.js.map